module.exports = __webpack_public_path__ + "static/media/jax.665de1fc.png";